import React from 'react';
import Input from '../atoms/Input';
import Textarea from '../atoms/Textarea';
import Button from '../atoms/Button';
import { useTranslation } from 'react-i18next';

const ContactForm = ({
  formData,
  onChange,
  onSubmit,
  serviceName = '',
  showPhone = true,
  submitText,
  className = ''
}) => {
  const { t } = useTranslation();

  // 送信テキストが指定されていない場合は翻訳から取得
  const finalSubmitText = submitText || t('common.submit');
  return (
    <form onSubmit={onSubmit} className={`space-y-4 ${className}`}>
      <Input
        label={t('contact.form.name')}
        type="text"
        required
        value={formData.name}
        onChange={(e) => onChange({ ...formData, name: e.target.value })}
      />

      <Input
        label={t('contact.form.email')}
        type="email"
        required
        value={formData.email}
        onChange={(e) => onChange({ ...formData, email: e.target.value })}
      />

      {showPhone && (
        <Input
          label={t('contact.form.phone')}
          type="tel"
          value={formData.phone}
          onChange={(e) => onChange({ ...formData, phone: e.target.value })}
        />
      )}

      <Textarea
        label={t('contact.form.message')}
        required
        placeholder={serviceName ?
          t('contact.form.servicePlaceholder') :
          t('contact.form.generalPlaceholder')
        }
        value={formData.message}
        onChange={(e) => onChange({ ...formData, message: e.target.value })}
      />

      <div className="flex justify-end">
        <Button type="submit">
          {finalSubmitText}
        </Button>
      </div>
    </form>
  );
};

export default ContactForm;
